const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

const mergeObjects = (values) => values.reduce((result, value) => {
  if (!isObject(value)) return result;
  Object.entries(value).forEach(([key, child]) => {
    if (isObject(child) && isObject(result[key])) {
      result[key] = mergeObjects([result[key], child]);
    } else if (Array.isArray(child) && Array.isArray(result[key])) {
      result[key] = [...new Set([...result[key], ...child])];
    } else {
      result[key] = child;
    }
  });
  return result;
}, {});

export const getGrandhamData = (vatu = {}) => {
  return isObject(vatu.grandham_data) ? vatu.grandham_data : {};
};

export const getGrandhamPhase = (vatu, phase) => {
  const data = getGrandhamData(vatu);
  return Object.fromEntries(
    Object.entries(data)
      .filter(([, value]) => isObject(value) && value[phase])
      .map(([type, value]) => [type, value[phase]])
  );
};

export const getGrandhamTypePhase = (vatu, type, phase) =>
  Object.entries(getGrandhamPhase(vatu, phase)[type] || {})
    .filter(([key]) => /^\d{4}$/.test(key))
    .reduce((result, [, value]) => mergeObjects([result, value]), 
      Object.keys(getGrandhamPhase(vatu, phase)[type] || {}).some((key) => /^\d{4}$/.test(key))
        ? {}
        : (getGrandhamPhase(vatu, phase)[type] || {}));
